<template>
  <form v-if="!reseting" :class="classes" @submit.stop.prevent="onSubmit" novalidate>
    <slot></slot>
  </form>
</template>

<script>
import { provide as provider } from '../../mixins/registrable'
import { nextTick } from 'nandos-timing-utils'

export default {

  mixins: [ provider('form') ],

  props: {
    inline: { type: Boolean }
  },

  data() {
    return {
      controls: [],
      reseting: false,
    }
  },

  computed: {
    classes() {
      return {
        'form': true,
        'form--inline': this.inline,
      }
    },

    invalidControls() {
      return this.controls
        .filter(control => control.valid == false)
        .filter(control => control._isDestroyed == false)
    },

    isValid() {
      return this.invalidControls.length == 0
    }
  },

  watch: {
    isValid: {
      handler(val) {
        this.$emit('validity', val)
      },
      immediate: true
    },
  },

  methods: {

    // registrable-provider-register
    register(control) {
      this.controls.push(control)
    },

    // registrable-provider-unregister
    unregister(control) {
      let index = this.controls.indexOf(control)
      if(index >= 0) this.controls.splice(index, 1)
    },

    submit() {
      return this.onSubmit()
    },

    onSubmit() {
      this.$el.checkValidity()
      this.controls.forEach(control => control.validate())

      if(this.isValid) {
        this.$emit('submit')
      }
      else {
        this.invalidControls[0].$refs.controlEl.focus()
        this.$emit('error', this.invalidControls[0].$refs.controlEl)
        return false
      }
    },

    reset() {
      this.reseting = true
      nextTick(() => this.reseting = false)
    },
  }
}
</script>